import { render } from "./DhDateTime.vue?vue&type=template&id=48e16608"
import script from "./DhDateTime.vue?vue&type=script&lang=ts"
export * from "./DhDateTime.vue?vue&type=script&lang=ts"
script.render = render

export default script